const isNode = require('./isNode');

const environment = isNode() ? process.env.NODE_CONFIG_ENV || process.env.NODE_ENV : window.__ENV__; 
let clientJioCDNEnabled = false;
let assetConfig = {};
let clientJioCDNUrl = '';
if(!isNode()) {
   if(window && window.__PRELOADED_STATE__ && window.__PRELOADED_STATE__.flags) {
   assetConfig = window.__PRELOADED_STATE__.flags.assetConfig;
   clientJioCDNEnabled =  assetConfig && assetConfig.isJioCDNEnabled === 'ON';
   clientJioCDNUrl = assetConfig && assetConfig.jioCDNAssetUrl || '';
}
}
const rComConfig = require('../ajio-config/index.js').init(environment);

module.exports = {
  getProperty(name, isNodeServer = false, isJioCDNEnabled = false, jioCDNUrl = '', isJioCDNJsCssFetchEnable = false) {
    if (!rComConfig || !rComConfig.properties) {
      return undefined;
    }
    const properties = rComConfig.properties;
    const isImageBaseUrl = name === 'imageBaseUrl';
    const isAssetUrl = name === 'assetUrl';
    if ((isImageBaseUrl || isAssetUrl) && !isNodeServer) {
      if (clientJioCDNEnabled) {
        return clientJioCDNUrl;
      }
    } else if (isImageBaseUrl && isNodeServer && isJioCDNEnabled) {
        return jioCDNUrl;
    } else if (isAssetUrl && isJioCDNJsCssFetchEnable && isNodeServer && isJioCDNEnabled) {
        return jioCDNUrl;
    }
    return properties[name];
  }  
};
